module.exports = __webpack_public_path__ + "img/ob3.16384987.png";